import { useState } from "react";
import { ChevronDown, Menu, X } from "lucide-react";
import {
    LOGO, SERVICES, SOLUTIONS, SOLUTIONS_GROUP, FRAMEWORKS, ABOUT, RESOURCES,
    PRICING, PORTAL_LOGIN, PORTAL_REGISTER, CONTACT,
} from "./gdprData";

const NavDropdown = ({ label, items, groupLabel }) => (
    <div className="relative group" data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}>
        <button className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-asphalt hover:text-aqua transition-colors">
            {label}
            <ChevronDown className="w-4 h-4" />
        </button>
        <div className="absolute left-0 top-full pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
            <div className="bg-white border border-line rounded-md shadow-xl py-2 min-w-[290px]">
                {groupLabel && (
                    <p className="px-4 pt-1 pb-1.5 text-[11px] font-bold uppercase tracking-wide text-muted">{groupLabel}</p>
                )}
                {items.map((it) => (
                    <a key={it.label} href={it.href}
                        className="block px-4 py-2 text-sm text-asphalt hover:bg-aqua-tint transition-colors whitespace-nowrap">
                        {it.label}
                    </a>
                ))}
            </div>
        </div>
    </div>
);

export const Header = () => {
    const [open, setOpen] = useState(false);
    const groups = [
        { label: "Services", items: SERVICES },
        { label: "Solutions", items: SOLUTIONS, groupLabel: SOLUTIONS_GROUP },
        { label: "Frameworks", items: FRAMEWORKS },
        { label: "About Us", items: ABOUT },
        { label: "Resources", items: RESOURCES },
    ];

    return (
        <header className="sticky top-0 z-40 bg-white border-b border-line" data-testid="site-header">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-[68px]">
                <a href="https://gdprlocal.com/" className="flex items-center shrink-0" data-testid="header-logo-link">
                    <img src={LOGO} alt="GDPR Local" className="h-10 w-auto" />
                </a>

                <nav className="hidden lg:flex items-center">
                    {groups.slice(0, 3).map((g) => <NavDropdown key={g.label} {...g} />)}
                    <a href={PRICING} className="px-3 py-2 text-sm font-medium text-asphalt hover:text-aqua transition-colors">Pricing</a>
                    {groups.slice(3).map((g) => <NavDropdown key={g.label} {...g} />)}
                </nav>

                <div className="hidden lg:flex items-center gap-3">
                    <a href={PORTAL_LOGIN} className="text-sm font-medium text-asphalt hover:text-aqua transition-colors">Sign in</a>
                    <a href={CONTACT} className="text-sm font-medium px-4 py-2 rounded-md border border-asphalt text-asphalt hover:bg-asphalt-tint transition-colors">Contact sales</a>
                    <a href={PORTAL_REGISTER} data-testid="header-signup"
                        className="text-sm font-medium px-4 py-2 rounded-md bg-aqua text-asphalt hover:brightness-95 transition-all">Sign up free</a>
                </div>

                <button className="lg:hidden text-asphalt" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
                    {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden border-t border-line max-h-[80vh] overflow-y-auto gdpr-scroll" data-testid="mobile-menu">
                    {groups.map((g) => (
                        <div key={g.label} className="px-4 py-2 border-b border-line">
                            <p className="text-xs font-bold uppercase text-muted mb-1">{g.label}</p>
                            {g.items.map((it) => (
                                <a key={it.label} href={it.href} className="block py-1.5 text-sm text-asphalt">{it.label}</a>
                            ))}
                        </div>
                    ))}
                    <div className="p-4 flex flex-col gap-2">
                        <a href={PRICING} className="text-sm font-medium text-asphalt">Pricing</a>
                        <a href={PORTAL_LOGIN} className="text-sm font-medium text-asphalt">Sign in</a>
                        <a href={CONTACT} className="text-sm font-medium px-4 py-2 rounded-md border border-asphalt text-asphalt text-center">Contact sales</a>
                        <a href={PORTAL_REGISTER} className="text-sm font-medium px-4 py-2 rounded-md bg-aqua text-asphalt text-center">Sign up free</a>
                    </div>
                </div>
            )}
        </header>
    );
};
